// filepath: /home/nicklargent/code/merch-data-explorer/website/src/components/DealerLookup/DealerInfo.js
import Spinner from 'react-bootstrap/Spinner';

function DealerInfo(props) {
    const ewsDealer = props.ewsDealer;
    const corgData = props.corgData;
    const cviConfigData = props.cviConfigData;
    const corgLoading = props.corgLoading;

    // Show initial spinner only when we have absolutely no data and no loading state
    if (!ewsDealer && !corgData && !cviConfigData && !corgLoading) {
      return <Spinner animation="border" size="sm" />;
    }
    
    return (
      <div className="dealer-info">
        {/* When EWS data is available, show it as primary and collapse CORG data */}
        {ewsDealer && (
          <>
            <h5 className="mt-0 mb-3">
              {ewsDealer.name} <span className="badge bg-primary">vAuto</span>
            </h5>
            <div className="mb-3">
              <div><strong>vAuto LogicalId:</strong> {ewsDealer.logicalId}</div>
              <div><strong>vAuto DealerId:</strong> {ewsDealer.id}</div>
              <div><strong>Platform ID:</strong> {ewsDealer.platformId}</div>
              <div><strong>Common Org ID:</strong> {ewsDealer.commonOrgId}</div>
              <div><strong>Address:</strong> {ewsDealer.address.line}, {ewsDealer.address.postalCode}</div>
            </div>
          </>
        )}
        
        {/* When only CORG data is available, show it as primary with all details */}
        {!ewsDealer && corgData && (
          <>
            <h5 className="mt-0 mb-3">
              {corgData.legalName} <span className="badge bg-secondary">CORG</span>
            </h5>
            <div className="mb-3">
              <div><strong>No vAuto Data</strong></div>
              {corgData.platformIds && corgData.platformIds.length > 0 && (
                <div><strong>Platform ID:</strong> {corgData.platformIds[0]}</div>
              )}
              <div><strong>Common Org ID:</strong> {corgData.commonOrgId}</div>
              <div><strong>Address:</strong> {corgData.address.street}, {corgData.address.city}, {corgData.address.state} {corgData.address.zip}</div>
              
              {/* Wrap OEM IDs in an Additional Details block */}
              <details className="mt-3 mb-2">
                <summary><strong>Additional Details</strong></summary>
                <div className="mt-2">
                  {corgData.oems && corgData.oems.length > 1 && (
                    <div><strong>OEM IDs:</strong> {corgData.oems.map(x => (
                      <div key={x.description + ":" + x.oemId}>{x.description} ({x.oemId})</div>
                      ))}
                    </div>
                  )}
                  {corgData.oems && corgData.oems.length === 1 && (
                    <div><strong>OEM IDs:</strong> {corgData.oems.map(x => (
                      <span key={x.oemId}>{x.description} ({x.oemId})</span>
                      ))}
                    </div>
                  )}
                </div>
              </details>
            </div>
          </>
        )}
        
        {/* When only CVI config data is available, show it as primary */}
        {!ewsDealer && !corgData && cviConfigData && (
          <>
            <h5 className="mt-0 mb-3">
              Entity {cviConfigData.entityId} <span className="badge bg-info">CVI</span>
            </h5>
            <div className="mb-3">
              <div><strong>No Dealer Name Available</strong></div>
              <div><strong>Entity ID:</strong> {cviConfigData.entityId}</div>
              <div><strong>Tenant ID:</strong> {cviConfigData.tenantId}</div>
              <div><strong>Dealer Source:</strong> {cviConfigData.dealerSource}</div>
            </div>
          </>
        )}
        
        {corgLoading ? (
          <div className="mb-3">
            <strong>Loading organization data...</strong> <Spinner animation="border" size="sm" />
          </div>
        ) : corgData && ewsDealer ? (
          <details className="mb-3">
            <summary><strong>Additional CORG Details</strong></summary>
            <div className="mt-2 mb-2">
              {corgData.legalName && <div><strong>Legal Name:</strong> {corgData.legalName}</div>}
              {corgData.address && (
                <div>
                  <strong>Address:</strong> {corgData.address.street}, {corgData.address.city}, {corgData.address.state} {corgData.address.zip}
                </div>
              )}
            </div>
            
            <div>
            {corgData.oems && corgData.oems.length > 1 && (
              <div><strong>OEM IDs:</strong> {corgData.oems.map(x => (
                <div key={x.description + ":" + x.oemId}>{x.description} ({x.oemId})</div>
                ))}</div>
            )}
            {corgData.oems && corgData.oems.length === 1 && (
              <div><strong>OEM IDs:</strong> {corgData.oems.map(x => (
                <span key={x.oemId}>{x.description} ({x.oemId})</span>
                ))}</div>
            )}
            </div>
          </details>
        ) : null}
      </div>
    );
}

export default DealerInfo;
